/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendblueMessageReference
 */
export interface SendblueMessageReference {
    /**
     * 
     * @type {string}
     * @memberof SendblueMessageReference
     */
    messageHandle: string;
    /**
     * 
     * @type {number}
     * @memberof SendblueMessageReference
     */
    partIndex?: number | null;
}

/**
 * Check if a given object implements the SendblueMessageReference interface.
 */
export function instanceOfSendblueMessageReference(value: object): value is SendblueMessageReference {
    if (!('messageHandle' in value) || value['messageHandle'] === undefined) return false;
    return true;
}

export function SendblueMessageReferenceFromJSON(json: any): SendblueMessageReference {
    return SendblueMessageReferenceFromJSONTyped(json, false);
}

export function SendblueMessageReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendblueMessageReference {
    if (json == null) {
        return json;
    }
    return {
        
        'messageHandle': json['message_handle'],
        'partIndex': json['part_index'] == null ? undefined : json['part_index'],
    };
}

export function SendblueMessageReferenceToJSON(json: any): SendblueMessageReference {
    return SendblueMessageReferenceToJSONTyped(json, false);
}

export function SendblueMessageReferenceToJSONTyped(value?: SendblueMessageReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message_handle': value['messageHandle'],
        'part_index': value['partIndex'],
    };
}

